var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileNotchPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.5H4.5C4.21875 12.5 4 12.75 4 13C4 13.2812 4.21875 13.5 4.5 13.5H7.5C7.75 13.5 8 13.2812 8 13C8 12.75 7.75 12.5 7.5 12.5ZM9.5 0H2.5C1.375 0 0.5 0.90625 0.5 2V14C0.5 15.125 1.375 16 2.5 16H9.5C10.5938 16 11.5 15.125 11.5 14V2C11.5 0.90625 10.5938 0 9.5 0ZM10 14C10 14.2812 9.75 14.5 9.5 14.5H2.5C2.21875 14.5 2 14.2812 2 14V2C2 1.75 2.21875 1.5 2.5 1.5H4V2.5C4 2.78125 4.21875 3 4.5 3H7.5C7.75 3 8 2.78125 8 2.5V1.5H9.5C9.75 1.5 10 1.75 10 2V14Z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileNotchPhone);
export default __webpack_public_path__ + "static/media/mobile-notch-phone.2f22bbeb4f823be2d8126d93b3badff1.svg";
export { ForwardRef as ReactComponent };